import React from 'react';

import LoadingIcon from 'theme/components/LoadingIcon/LoadingIcon';
import './LoadingScreen.scss';

const LoadingScreen = () => (
  <div id='loading-screen' className='loading-screen'>
    <LoadingIcon />
  </div>
);

export default LoadingScreen;
